import React from "react";
import NflUtil from "../../util/nflUtil";
import PlayerImageByPos from "../player/PlayerImageByPos";
import {
  getPlayerInjuryCross,
  getPosPlayerFullNameTeam,
} from "../player/PlayerName";

export default function PlayerCard({
  player,
  backgroundColor,
  rightSide,
  leftSide,
  isAnimated,
  style,
}) {
  const injury = getPlayerInjuryCross(player);

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexFlow: "row wrap",
        fontSize: "1rem",
        color: "white",
        backgroundColor,
        ...style,
      }}
    >
      {leftSide}
      <div
        style={{
          display: "flex",
          alignItems: "center",
        }}
      >
        <PlayerImageByPos player={player} isAnimated={isAnimated} />
      </div>
      <div
        style={{
          padding: "0.25rem",
        }}
        title={getPosPlayerFullNameTeam(player)}
      >
        {player.firstName}
        <br />
        <span style={{ fontSize: "1.5rem" }}>{player.lastName}</span>
        {injury}
        <br />
        {player.pos}
        {player.nflTeamAbbr
          ? " - " + NflUtil.formatNflTeamAbbr(player.nflTeamAbbr)
          : null}
      </div>
      {rightSide}
    </div>
  );
}
